import { patientApiRequest, ApiAuth } from "../../../lib/api";
import {
  CreditSummary,
  CreditSummaryResponseSchema,
  IssueCreditResponse,
  IssueCreditResponseSchema,
} from "./types";

// Patient self-service credit. The patient identity is ALWAYS server-derived
// from the verified token (never sent in the body) — the patient can only read/
// load credit on their OWN account. organizationId/locationId are config.
export type CreditContext = {
  locationId?: string | null;
  organizationId?: string | null;
};

export const creditsApi = {
  async get(auth: ApiAuth, ctx: CreditContext = {}): Promise<CreditSummary> {
    const data = await patientApiRequest(auth, {
      method: "POST",
      url: "/patient-app/credits/get",
      data: { organizationId: ctx.organizationId ?? null },
    });
    return CreditSummaryResponseSchema.parse(data).credit;
  },

  // `idempotencyKey` names the attempt (Billing/paymentAttempt.ts): the server
  // answers a key once and gives Stripe the same key, so a retry of the same
  // attempt is never a second charge.
  async issueStripe(
    auth: ApiAuth,
    body: {
      amountCents: number;
      paymentMethodId: string;
      locationId?: string | null;
      organizationId?: string | null;
    },
    idempotencyKey?: string | null
  ): Promise<IssueCreditResponse> {
    const data = await patientApiRequest(auth, {
      method: "POST",
      url: "/patient-app/credits/issue-stripe",
      data: body,
      ...(idempotencyKey ? { headers: { "Idempotency-Key": idempotencyKey } } : {}),
    });
    return IssueCreditResponseSchema.parse(data);
  },

  async finalizeStripe(
    auth: ApiAuth,
    body: {
      paymentIntentId: string;
      amountCents: number;
      locationId?: string | null;
      organizationId?: string | null;
    }
  ): Promise<IssueCreditResponse> {
    const data = await patientApiRequest(auth, {
      method: "POST",
      url: "/patient-app/credits/issue-stripe/finalize",
      data: body,
    });
    return IssueCreditResponseSchema.parse(data);
  },
};
